// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-old {
  display: none;
}

/* Variables */
/* ===================
    From   MyDataHelpsUI/src/helpers/globalCss.ts
=================== */
.participant-login-container {
  --mdhui-color-primary: rgba(0, 127, 249, 1);
  --mdhui-color-success: #00AE42;
  --mdhui-color-warning: rgb(232, 124, 0);
  --mdhui-color-danger: rgb(239, 55, 36);
  --mdhui-fadein-animation: fadein 1s;
  --mdhui-card-border-radius: 12px;
  --mdhui-font-family: ui-rounded, -apple-system, Helvetica, Arial, sans-serif;
  --mdhui-modal-overlay-color: rgba(0, 0, 0, 0.5);
  
  --mdhui-padding-xxs: 4px;
  --mdhui-padding-xs: 8px;
  --mdhui-padding-sm: 12px;
  --mdhui-padding-md: 16px;
  --mdhui-padding-lg: 24px;

  --mdhui-touch: 44px;
}
/* ===================
    Design System to admin.css mappings, for checkbox and other shared components
=================== */
.participant-login-container {
  --blue: var(--mdhui-color-primary);
  --default_text_color: var(--ce-grey-90);
  --border_radius: var(--ce-border-radius-default);
  --highlight-border: var(--ce-blue-20);
  --min_touch_target: 36px;
  --ideal_touch_target: 44px;
  /* typography */
  --text_sm: 12px;
  --text_md: var(--ce-body-default);
  --text_lg: 20px;
}
/* ===================
    Authentication-specific vars
=================== */
.participant-login-container {
  --section-padding: 7rem;
  --short-form-max-width: 400px;
}

@media (max-width: 767px) {
  .participant-login-container {
    --section-padding: 5rem;
  }
}

.participant-login-container *,
.participant-login-container *:before,
.participant-login-container *:after {
  box-sizing: border-box;
  -webkit-font-smoothing:antialiased;
  -moz-osx-font-smoothing:grayscale;
}
.participant-login-container  {
    background-color: var(--ce-grey-1);
    color: var(--default_text_color);
    line-height: 1.4;
}
.participant-login-container button, 
.participant-login-container input, 
.participant-login-container optgroup, 
.participant-login-container select, 
.participant-login-container textarea {
    line-height: 1.3;
    font-size: var(--ce-body-default);
}


/* Typography */
.participant-login-container h1, .participant-login-container h2, .participant-login-container h3, .participant-login-container h4, .participant-login-container h5, .participant-login-container h6 {
  font-weight: 600;
}
.participant-login-container strong {
  font-weight: 600;
}
.participant-login-container {
  font-size: var(--ce-body-default);
}
.participant-login-container h1 {
  font-size: var(--ce-h1);
  line-height: 1.3;
}
.participant-login-container h2 {
  font-size: var(--ce-h2);
  line-height: 1.3;  
}
.participant-login-container h3 {
  font-size: var(--ce-h3);
  line-height: 1.3;
  margin-bottom: 4px;
}
.participant-login-container h4 {
  font-size: var(--ce-h4);
  line-height: 1.4;
}
.participant-login-container h5 {
  font-size: var(--ce-h5);
  line-height: 1.3;
}
.participant-login-container h6 {
  font-size: var(--ce-h6);
  line-height: 1.3;
}

/* Utilities */
.desktop-flex {
  display: flex;
}
.mobile-flex {
  display: none;
}
@media (max-width: 767px) {
  .desktop-flex {
    display: none;
  }
  .mobile-flex {
    display: flex;
  }
}

/* Form elements */
.user-participant .input-container input,
.user-participant input {
  border-color: var(--ce-grey-90);
}
.participant-login-container .field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.participant-login-container .field-group label {
  font-weight: 500;
  padding-bottom: 3px;
  text-align: left;
}
.participant-login-container .combo-input-group {
    display: flex;
    margin-left: 0;
    margin-right: var(--target_spacing);
}
.participant-login-container .combo-input-group .input-container input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin-right: -1px;
    padding-right: 6px;
}
.participant-login-container .combo-input-group .button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: var(--border);
}

#participantLogin label > div {
  margin-bottom: 0.25em !important;
}

.password-mask-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  color: white;
  background: black;
  width: 46px;
  cursor: pointer;
  z-index: 2;
  margin-left: -2px;
  border: 0;
  border-top-right-radius: var(--ce-border-radius-default);
  border-bottom-right-radius: var(--ce-border-radius-default);
}
.disclaimer {
  font-size: 13px;
  color: var(--ce-grey-55);
}
label[for="rememberMe"] {
  justify-content: center;
}

/* Other shared */

#authentication {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#authentication main.simple-layout {
  flex: 1;
}

main.simple-layout {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  min-height: calc(100vh - 151px);
}

.try-mdh-container {
  max-width: var(--short-form-max-width);
  width: 100%;
}

@media (min-width: 768px) {
  .try-mdh-container,
  .authentication-action,
  .brand-sidebar {
    width: 50%;
    padding: var(--ce-base-padding-large) var(--ce-base-padding-default);
  }
}

@media (max-width: 767px) {
  main.simple-layout {
    flex-direction: column-reverse;
  }

  .brand-sidebar,
  .authentication-action {
    width: 100%;
    flex: 1;
    padding: var(--ce-base-padding-default) var(--ce-base-padding-large) 20px
      var(--ce-base-padding-large);
    align-items: center;
    justify-content: center;
  }
}

.brand-sidebar {
  display: flex;
}

.authentication-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 80px;
}

.unbranded .authentication-action {
  justify-content: center;
}

.authentication-action .header {
  width: var(--short-form-max-width);
}

.authentication-action-content {
  width: var(--short-form-max-width);
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

@media (max-width: 767px) {
  .authentication-action-content {
    margin-bottom: 40px;
  }
}

#authentication.user-participant .authentication-action-content .login-action {
  background: var(--ce-grey-4);
  border-radius: 10px;
}

.authentication-action-content .login-action {
  padding: var(--ce-base-padding-large);
  text-align: center;
  gap: 12px;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: fit-content;
}

.authentication-action .project {
  position: relative;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}

.authentication-action .project-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 10px;
}

.authentication-action .projectless-logo {
  width: 200px;
}
.authentication-action .project-logo {
  width: 200px;
  height: auto;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.authentication-action .project-logo img {
  max-height: 100%;
  max-width: 100%;
}

.authentication-action .project-information {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.authentication-action .project-description {
  margin-top: var(--ce-base-padding-default);
}

.authentication-action .project-information .project-name {
  margin-bottom: 0;
  padding-bottom: 0;
}

.authentication-action .project-information .project-organization {
  color: var(--ce-grey-55);
}

@media (max-width: 767px) {
  .authentication-action-content {
    margin-bottom: 0;
  }

  .authentication-action .project-header {
    flex-direction: column;
  }

  .authentication-action .project-logo {
    margin: 0 auto;
  }

  .authentication-action .project-information {
    border-left: none;
    padding-left: 0;
    text-align: center;
  }
}

.logo-header-mobile {
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: var(--ce-blue-vivid-10);
  padding: var(--ce-base-padding-large);
  width: 100%;
}

.logo-header-mobile img {
  margin-bottom: 0;
}

.logo-app-icon {
  max-width: 60%;
  margin-bottom: 21px;
}

@media (max-width: 767px) {
  .logo-header-mobile {
    display: flex;
    background-color: #fff;
    align-self: center;
    justify-content: center;
    padding: var(--section-padding) var(--ce-base-padding-default)
      var(--ce-base-padding-large) var(--ce-base-padding-default);
  }
  .logo-header-mobile-image-wrap {
    width: var(--short-form-max-width);
    max-width: 100%;
    display: flex;
    justify-content: flex-start;
  }
  .logo-app-icon {
    width: 250px;
    max-width: 100%;
  }
}

/* Try MDHD link */

#authentication a.try-mdhd {
  text-decoration: none;
  display: flex;
  background: var(--ce-blue-vivid-5);
  align-items: center;
  padding: 13px 15px;
  border-radius: 10px;
  margin-top: 40px;
}

.try-mdhd-logo {
  padding-right: 10px;
}

.try-mdhd-message {
  display: flex;
  flex-direction: column;
  color: var(--ce-blue-vivid-90);
  flex: 1;
  line-height: 1.4;
}

/* Footer */

.authentication-footer {
  background-color: var(--ce-grey-99);
  padding: var(--ce-base-padding-large);
  justify-content: center;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.authentication-footer .footer-content {
  display: flex;
  align-items: center;
  flex-direction: row;
  max-width: 1300px;
  width: 100%;
  justify-content: space-between;
}

.footer-top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}

.authentication-action .sub-action {
  padding: var(--ce-interactable-padding-default);
}

/* Errors */

.server-error {
    color: var(--ce-red-55);
    background: var(--ce-red-2);
    border: 1px solid var(--ce-red-10);
    border-radius: var(--border_radius);
    padding: 8px 12px;
}

.client-error-container {
    background: var(--ce-violet-2);
    border: 1px solid var(--ce-violet-10);
    margin-bottom: 2rem;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px;
    border-radius: var(--border_radius);
}

/* Turnstile */

.cf-turnstile.interactive {
  margin-bottom: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Participant/authentication.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA,cAAc;AACd;;qBAEqB;AACrB;EACE,2CAA2C;EAC3C,8BAA8B;EAC9B,uCAAuC;EACvC,sCAAsC;EACtC,mCAAmC;EACnC,gCAAgC;EAChC,4EAA4E;EAC5E,+CAA+C;;EAE/C,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,mBAAmB;AACrB;AACA;;qBAEqB;AACrB;EACE,kCAAkC;EAClC,uCAAuC;EACvC,gDAAgD;EAChD,qCAAqC;EACrC,wBAAwB;EACxB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;AACA;;qBAEqB;AACrB;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;;;EAGE,sBAAsB;EACtB,kCAAkC;EAClC,iCAAiC;AACnC;AACA;IACI,kCAAkC;IAClC,gCAAgC;IAChC,gBAAgB;AACpB;AACA;;;;;IAKI,gBAAgB;IAChB,iCAAiC;AACrC;;;AAGA,eAAe;AACf;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA,kBAAkB;AAClB;;EAEE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;IACI,aAAa;IACb,cAAc;IACd,mCAAmC;AACvC;AACA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;AACtB;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,SAAS;EACT,wDAAwD;EACxD,2DAA2D;AAC7D;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;;AAEA,iBAAiB;;AAEjB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE;;;IAGE,UAAU;IACV,oEAAoE;EACtE;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;IACX,OAAO;IACP;kCAC8B;IAC9B,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB;iEAC6D;EAC/D;EACA;IACE,kCAAkC;IAClC,eAAe;IACf,aAAa;IACb,2BAA2B;EAC7B;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,kBAAkB;;AAElB;EACE,qBAAqB;EACrB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,OAAO;EACP,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE,mCAAmC;EACnC,qCAAqC;EACrC,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,+CAA+C;AACjD;;AAEA,WAAW;;AAEX;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,kCAAkC;IAClC,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,mCAAmC;AACvC;;AAEA,cAAc;;AAEd;EACE,mBAAmB;AACrB","sourcesContent":[".login-old {\n  display: none;\n}\n\n/* Variables */\n/* ===================\n    From   MyDataHelpsUI/src/helpers/globalCss.ts\n=================== */\n.participant-login-container {\n  --mdhui-color-primary: rgba(0, 127, 249, 1);\n  --mdhui-color-success: #00AE42;\n  --mdhui-color-warning: rgb(232, 124, 0);\n  --mdhui-color-danger: rgb(239, 55, 36);\n  --mdhui-fadein-animation: fadein 1s;\n  --mdhui-card-border-radius: 12px;\n  --mdhui-font-family: ui-rounded, -apple-system, Helvetica, Arial, sans-serif;\n  --mdhui-modal-overlay-color: rgba(0, 0, 0, 0.5);\n  \n  --mdhui-padding-xxs: 4px;\n  --mdhui-padding-xs: 8px;\n  --mdhui-padding-sm: 12px;\n  --mdhui-padding-md: 16px;\n  --mdhui-padding-lg: 24px;\n\n  --mdhui-touch: 44px;\n}\n/* ===================\n    Design System to admin.css mappings, for checkbox and other shared components\n=================== */\n.participant-login-container {\n  --blue: var(--mdhui-color-primary);\n  --default_text_color: var(--ce-grey-90);\n  --border_radius: var(--ce-border-radius-default);\n  --highlight-border: var(--ce-blue-20);\n  --min_touch_target: 36px;\n  --ideal_touch_target: 44px;\n  /* typography */\n  --text_sm: 12px;\n  --text_md: var(--ce-body-default);\n  --text_lg: 20px;\n}\n/* ===================\n    Authentication-specific vars\n=================== */\n.participant-login-container {\n  --section-padding: 7rem;\n  --short-form-max-width: 400px;\n}\n\n@media (max-width: 767px) {\n  .participant-login-container {\n    --section-padding: 5rem;\n  }\n}\n\n.participant-login-container *,\n.participant-login-container *:before,\n.participant-login-container *:after {\n  box-sizing: border-box;\n  -webkit-font-smoothing:antialiased;\n  -moz-osx-font-smoothing:grayscale;\n}\n.participant-login-container  {\n    background-color: var(--ce-grey-1);\n    color: var(--default_text_color);\n    line-height: 1.4;\n}\n.participant-login-container button, \n.participant-login-container input, \n.participant-login-container optgroup, \n.participant-login-container select, \n.participant-login-container textarea {\n    line-height: 1.3;\n    font-size: var(--ce-body-default);\n}\n\n\n/* Typography */\n.participant-login-container h1, .participant-login-container h2, .participant-login-container h3, .participant-login-container h4, .participant-login-container h5, .participant-login-container h6 {\n  font-weight: 600;\n}\n.participant-login-container strong {\n  font-weight: 600;\n}\n.participant-login-container {\n  font-size: var(--ce-body-default);\n}\n.participant-login-container h1 {\n  font-size: var(--ce-h1);\n  line-height: 1.3;\n}\n.participant-login-container h2 {\n  font-size: var(--ce-h2);\n  line-height: 1.3;  \n}\n.participant-login-container h3 {\n  font-size: var(--ce-h3);\n  line-height: 1.3;\n  margin-bottom: 4px;\n}\n.participant-login-container h4 {\n  font-size: var(--ce-h4);\n  line-height: 1.4;\n}\n.participant-login-container h5 {\n  font-size: var(--ce-h5);\n  line-height: 1.3;\n}\n.participant-login-container h6 {\n  font-size: var(--ce-h6);\n  line-height: 1.3;\n}\n\n/* Utilities */\n.desktop-flex {\n  display: flex;\n}\n.mobile-flex {\n  display: none;\n}\n@media (max-width: 767px) {\n  .desktop-flex {\n    display: none;\n  }\n  .mobile-flex {\n    display: flex;\n  }\n}\n\n/* Form elements */\n.user-participant .input-container input,\n.user-participant input {\n  border-color: var(--ce-grey-90);\n}\n.participant-login-container .field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.participant-login-container .field-group label {\n  font-weight: 500;\n  padding-bottom: 3px;\n  text-align: left;\n}\n.participant-login-container .combo-input-group {\n    display: flex;\n    margin-left: 0;\n    margin-right: var(--target_spacing);\n}\n.participant-login-container .combo-input-group .input-container input {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    margin-right: -1px;\n    padding-right: 6px;\n}\n.participant-login-container .combo-input-group .button {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left: var(--border);\n}\n\n#participantLogin label > div {\n  margin-bottom: 0.25em !important;\n}\n\n.password-mask-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: none;\n  color: white;\n  background: black;\n  width: 46px;\n  cursor: pointer;\n  z-index: 2;\n  margin-left: -2px;\n  border: 0;\n  border-top-right-radius: var(--ce-border-radius-default);\n  border-bottom-right-radius: var(--ce-border-radius-default);\n}\n.disclaimer {\n  font-size: 13px;\n  color: var(--ce-grey-55);\n}\nlabel[for=\"rememberMe\"] {\n  justify-content: center;\n}\n\n/* Other shared */\n\n#authentication {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n#authentication main.simple-layout {\n  flex: 1;\n}\n\nmain.simple-layout {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: stretch;\n  min-height: calc(100vh - 151px);\n}\n\n.try-mdh-container {\n  max-width: var(--short-form-max-width);\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n  .try-mdh-container,\n  .authentication-action,\n  .brand-sidebar {\n    width: 50%;\n    padding: var(--ce-base-padding-large) var(--ce-base-padding-default);\n  }\n}\n\n@media (max-width: 767px) {\n  main.simple-layout {\n    flex-direction: column-reverse;\n  }\n\n  .brand-sidebar,\n  .authentication-action {\n    width: 100%;\n    flex: 1;\n    padding: var(--ce-base-padding-default) var(--ce-base-padding-large) 20px\n      var(--ce-base-padding-large);\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.brand-sidebar {\n  display: flex;\n}\n\n.authentication-action {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 80px;\n}\n\n.unbranded .authentication-action {\n  justify-content: center;\n}\n\n.authentication-action .header {\n  width: var(--short-form-max-width);\n}\n\n.authentication-action-content {\n  width: var(--short-form-max-width);\n  height: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n}\n\n@media (max-width: 767px) {\n  .authentication-action-content {\n    margin-bottom: 40px;\n  }\n}\n\n#authentication.user-participant .authentication-action-content .login-action {\n  background: var(--ce-grey-4);\n  border-radius: 10px;\n}\n\n.authentication-action-content .login-action {\n  padding: var(--ce-base-padding-large);\n  text-align: center;\n  gap: 12px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-width: fit-content;\n}\n\n.authentication-action .project {\n  position: relative;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n}\n\n.authentication-action .project-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 10px;\n}\n\n.authentication-action .projectless-logo {\n  width: 200px;\n}\n.authentication-action .project-logo {\n  width: 200px;\n  height: auto;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.authentication-action .project-logo img {\n  max-height: 100%;\n  max-width: 100%;\n}\n\n.authentication-action .project-information {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.authentication-action .project-description {\n  margin-top: var(--ce-base-padding-default);\n}\n\n.authentication-action .project-information .project-name {\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.authentication-action .project-information .project-organization {\n  color: var(--ce-grey-55);\n}\n\n@media (max-width: 767px) {\n  .authentication-action-content {\n    margin-bottom: 0;\n  }\n\n  .authentication-action .project-header {\n    flex-direction: column;\n  }\n\n  .authentication-action .project-logo {\n    margin: 0 auto;\n  }\n\n  .authentication-action .project-information {\n    border-left: none;\n    padding-left: 0;\n    text-align: center;\n  }\n}\n\n.logo-header-mobile {\n  display: none;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--ce-blue-vivid-10);\n  padding: var(--ce-base-padding-large);\n  width: 100%;\n}\n\n.logo-header-mobile img {\n  margin-bottom: 0;\n}\n\n.logo-app-icon {\n  max-width: 60%;\n  margin-bottom: 21px;\n}\n\n@media (max-width: 767px) {\n  .logo-header-mobile {\n    display: flex;\n    background-color: #fff;\n    align-self: center;\n    justify-content: center;\n    padding: var(--section-padding) var(--ce-base-padding-default)\n      var(--ce-base-padding-large) var(--ce-base-padding-default);\n  }\n  .logo-header-mobile-image-wrap {\n    width: var(--short-form-max-width);\n    max-width: 100%;\n    display: flex;\n    justify-content: flex-start;\n  }\n  .logo-app-icon {\n    width: 250px;\n    max-width: 100%;\n  }\n}\n\n/* Try MDHD link */\n\n#authentication a.try-mdhd {\n  text-decoration: none;\n  display: flex;\n  background: var(--ce-blue-vivid-5);\n  align-items: center;\n  padding: 13px 15px;\n  border-radius: 10px;\n  margin-top: 40px;\n}\n\n.try-mdhd-logo {\n  padding-right: 10px;\n}\n\n.try-mdhd-message {\n  display: flex;\n  flex-direction: column;\n  color: var(--ce-blue-vivid-90);\n  flex: 1;\n  line-height: 1.4;\n}\n\n/* Footer */\n\n.authentication-footer {\n  background-color: var(--ce-grey-99);\n  padding: var(--ce-base-padding-large);\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n}\n\n.authentication-footer .footer-content {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  max-width: 1300px;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.footer-top {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.authentication-action .sub-action {\n  padding: var(--ce-interactable-padding-default);\n}\n\n/* Errors */\n\n.server-error {\n    color: var(--ce-red-55);\n    background: var(--ce-red-2);\n    border: 1px solid var(--ce-red-10);\n    border-radius: var(--border_radius);\n    padding: 8px 12px;\n}\n\n.client-error-container {\n    background: var(--ce-violet-2);\n    border: 1px solid var(--ce-violet-10);\n    margin-bottom: 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 12px;\n    border-radius: var(--border_radius);\n}\n\n/* Turnstile */\n\n.cf-turnstile.interactive {\n  margin-bottom: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
